var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { RadioGroup } from '../../Components/FormFields/RadioGroup';
import { useField } from '../../Components/useForm/useField';
import { MedicationCourse, MedicationType, prettyPrintMedicationCourse } from '../../Contracts/MedicationModels';
import { MedicationExpiryType } from '../../Shared/Types';
export var EditMedicationCourseField = function (props) {
    var medicationCourseField = useField({ form: props.form, field: 'medicationCourse' });
    var medicationCourse = medicationCourseField.value;
    var isS8 = props.poisonScheduleCode !== null && props.poisonScheduleCode != '' ? props.poisonScheduleCode == 'S8' : false;
    var medicationTypeField = useField({ form: props.form, field: 'medicationType' });
    var medicationType = medicationTypeField.value;
    var medicationExpiryField = useField({ form: props.form, field: 'medicationExpiry' });
    var medicationIsAutoRemoveField = useField({ form: props.form, field: 'isAutoRemove' });
    function medicationCourseChanged(_, value) {
        if (medicationCourse === MedicationCourse.None &&
            ((medicationType === null || medicationType === void 0 ? void 0 : medicationType.value) === MedicationType.EnrmcScript ||
                (medicationType === null || medicationType === void 0 ? void 0 : medicationType.value) === MedicationType.ComplementaryTherapyOrder) &&
            value === MedicationCourse.ShortCourse
            // Once S8 is selecetd, med has already have the defaults, we don't want to override users entry in this case.
            && !isS8) {
            medicationExpiryField.setValue({ value: MedicationExpiryType.Fixed });
            medicationIsAutoRemoveField.setValue(true);
            props.setShortCourseDefaults(true);
        }
        else {
            props.setShortCourseDefaults(false);
        }
        medicationCourseField.setValue(value);
    }
    var medicationCourseControls = props.form.registerRadioGroup('medicationCourse');
    return (React.createElement(RadioGroup, __assign({}, medicationCourseControls, { readOnly: props.readOnly, label: 'Medication course', required: true, onChange: medicationCourseChanged, showErrorHelperText: true, errorText: medicationCourseControls.touched ? medicationCourseControls.errorText : '', options: [
            {
                label: prettyPrintMedicationCourse(MedicationCourse.Regular),
                value: MedicationCourse.Regular
            },
            {
                label: prettyPrintMedicationCourse(MedicationCourse.ShortCourse),
                value: MedicationCourse.ShortCourse
            },
            {
                label: prettyPrintMedicationCourse(MedicationCourse.AsRequired),
                value: MedicationCourse.AsRequired
            }
        ] })));
};
